import React from "react";
import Box from "@material-ui/core/Box";

import type { FC } from "react";

export const BACKGROUND_COLORS = {
  DEFAULT: "#fff",
  GRAY: "#f5f5f5",
} as const;

type Props = {
  bgcolor?: keyof typeof BACKGROUND_COLORS;
  children: React.ReactNode;
};

export const SubContentsLayout: FC<Props> = ({
  bgcolor = "DEFAULT",
  children,
}) => {
  return (
    <Box
      component={"main"}
      id="sub-contents"
      minHeight={"calc(100vh - 65px - 190px)"}
      paddingBottom={"80px"}
      bgcolor={BACKGROUND_COLORS[bgcolor]}
    >
      {children}
    </Box>
  );
};
